<template>
	<div>
		<div class="filter_panel">
			<el-form :inline="true" size="mini" :model="pages" class="filter_form">
				<el-form-item :label="$t('parent_index.tel')" data-name="电话">
					<el-input v-model="pages.tel" style="width:120px" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('parent_index.email')" data-name="邮箱">
					<el-input v-model="pages.email" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('parent_index.name')" data-name="姓名">
					<el-input v-model="pages.name" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('parent_index.name_child')" data-name="学生姓名">
					<el-input v-model="pages.student_name" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('parent_index.student_age')" data-name="年龄">
					<el-input v-model="pages.student_age_min" style="width:90px" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item label="-">
					<el-input v-model="pages.student_age_max" style="width:90px" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('parent_index.group_type')" data-name="会员等级">
					<el-select v-model="pages.group_type" class="w100" clearable :placeholder="$t('index.select')">
						<el-option v-for="(item,index) in CUSTOMER_LEVEL" :key="index" :label="item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('parent_index.province')" data-name="地区">
					<el-input v-model="pages.province" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<!-- <el-form-item :label="$t('parent_index.seller')" prop="seller_id">
					<el-select v-model="pages.seller_id" class="w100" :placeholder="$t('index.select')">
						<el-option v-for="(item,index) in sellerList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item :label="$t('feedback_index.create_time')" data-name="时间">
					<el-date-picker v-model="pages.time" value-format="timestamp" type="daterange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.startdate')" :end-placeholder="$t('course_index.enddate')"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="search()">{{$t('index.search')}}</el-button>
					<el-button type="primary" size="mini" @click="reset()">{{$t('index.reset')}}</el-button>
				</el-form-item>
			</el-form>
			<div class="filter_button">
				<div>
					<el-button type="primary" size="mini" @click="add('')" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
					<el-button type="primary" size="mini" @click="coupon('')" v-if="hasBtn('coupon')">{{$t('index.coupon')}}</el-button>
				</div>
				<div style="margin-top:10px;">
					<el-button type="info" size="mini" @click="del('')" v-if="hasBtn('del')">{{$t('index.del')}}</el-button>
					<el-button type="primary" size="mini" @click="exportUserList('')" v-if="hasBtn('export')">{{$t('index.export')}}</el-button>
				</div>
				<!-- <div style="margin-top:10px;">
					<el-button type="primary" size="mini" @click="exportUserList1('')" v-if="hasBtn('export')">{{$t('index.in_progress_export')}}</el-button>
				</div> -->
			</div>
		</div>
		<el-table :data="list" border size="mini" @selection-change="handleSelectionChange" @sort-change="sort_change">
			<el-table-column type="selection" width="40" align="center"></el-table-column>
			<el-table-column prop="id" align="center" label="ID" width="80"></el-table-column>
			<el-table-column prop="tel" align="center" :label="$t('parent_index.tel')"></el-table-column>
			<el-table-column prop="name" align="center" :label="$t('parent_index.name')"></el-table-column>
			<el-table-column prop="wechat_id" align="center" :label="$t('parent_index.wechat')"></el-table-column>
			<el-table-column prop="email" align="center" :label="$t('parent_index.email')"></el-table-column>
			<el-table-column prop="province" align="center" :label="$t('parent_index.province')"></el-table-column>
			<el-table-column prop="score" align="center" :label="$t('parent_index.score')" width="100" sortable="custom"></el-table-column>
			<el-table-column prop="children" align="center" :label="$t('parent_index.child')">
				<template slot-scope="scope">
					<div v-for="(item,index) in scope.row.children" :key="index">{{item.name_cn}}:{{item.name}}:{{item.age}}y</div>
				</template>
			</el-table-column>
			<el-table-column prop="referred_tel" align="center" :label="$t('parent_index.referred_tel')"></el-table-column>
			<el-table-column prop="leave_count" align="center" :label="$t('parent_index.leave_count')"></el-table-column>
			<el-table-column prop="remarks" align="center"  width="100" :label="$t('feedback_index.remarks')"></el-table-column>
			<el-table-column prop="create_time" align="center" :label="$t('feedback_index.create_time')">
				<template slot-scope="scope"> {{getTime_us(scope.row.create_time,'mmddyyyy')}}</template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right" width="250">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
					<!-- <el-button size="mini" type="primary" v-if="hasBtn('points')" @click="integral(scope.row)">{{$t('parent_index.integral')}}</el-button> -->
					<div style="margin-top:10px;">
						<el-button size="mini" type="primary" @click="remarks_ff(scope.row)">{{$t('feedback_index.remarks')}}</el-button>
						<el-button size="mini" type="primary" @click="user_id_id=scope.row.user_id,history_is=true">{{$t('feedback_index.history')}}</el-button>
						<el-button size="mini" type="primary" @click="user_id_id=scope.row.user_id,coupon_list_is=true">{{$t('feedback_index.coupon_list')}}</el-button>
					</div>
					<!-- <el-button size="mini" type="primary" v-if="hasBtn('order')" @click="order_list_email=scope.row.email">{{$t('parent_index.order')}}</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<pagination :total="pages.count" :page.sync="pages.page" :limit.sync="pages.perpage" @pagination="init" />
		<el-dialog :title="$t('index.dialog_title')" :close-on-click-modal="false" :visible.sync="editFormVisible_is" width="1200px">
			<el-form ref="editForm_form" size="mini" :model="editForm_form" :rules="rules" label-position="top">
				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.all_get')" prop="all_get">
							<el-input v-model="editForm_form.all_get" class="w100" readonly></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.score_min')" prop="score_min">
							<el-input v-model="editForm_form.score_min" class="w100" readonly></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.jiajian')" prop="jiajian">
							<el-select v-model="editForm_form.jiajian" class="w100" @chang="editForm_form.score=0" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?'加':'add'" :value="1"></el-option>
								<el-option :label="lang=='cn'?'减':'reduce'" :value="0"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.score')" prop="score" v-if="editForm_form.jiajian==1">
							<el-input-number v-model="editForm_form.score" :min="0"></el-input-number>
						</el-form-item>
						<el-form-item :label="$t('parent_index.score')" prop="score" v-if="editForm_form.jiajian==0">
							<el-input-number v-model="editForm_form.score" :min="0" :max="editForm_form.score_min"></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item :label="$t('parent_index.remarks')" prop="remarks">
							<el-input v-model="editForm_form.remarks" class="w100" :placeholder="$t('index.pleaseInput')" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<div class="dialog-footer">
					<el-button size="mini" @click.native="editFormVisible_is = false">{{$t('index.cancel')}}</el-button>
					<el-button size="mini" type="primary" @click.native="editSubmit_is">{{$t('index.submit')}}</el-button>
				</div>
				<el-table :data="editForm_list" border size="mini">
					<el-table-column prop="user_id" align="center" label="ID" width="90"></el-table-column>
					<el-table-column prop="user_name" align="center" :label="$t('journal.name')"></el-table-column>
					<el-table-column prop="email" align="center" :label="$t('journal.admin_email')"></el-table-column>
					<el-table-column prop="score" align="center" :label="$t('journal.score')" width="140"></el-table-column>
					<el-table-column prop="now_score" align="center" :label="$t('parent_index.score_min')" width="140"></el-table-column>
					<el-table-column prop="create_time" align="center" :label="$t('journal.create_time')">
						<template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}}</template>
					</el-table-column>
					<el-table-column prop="admin_name" align="center" :label="$t('journal.user_name')"></el-table-column>
					<el-table-column prop="name" align="center" :label="$t('student_list.remarks')">
						<template slot-scope="scope">
				      		{{lang=='cn'?scope.row.name_cn:scope.row.name}}
				      		{{lang=='cn'?scope.row.type_name.name_cn:scope.row.type_name.name}}
				      		{{scope.row.order_id}}
				      	</template>
					</el-table-column>
				    <el-table-column align="center" :label="$t('index.operation')" width="240">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="remarks_edit(scope.row)" data-name="修改备注">{{$t('student_list.edit_remarks')}}</el-button>
							<el-button type="info" size="mini"  @click="del_jilu(scope.row)">{{$t('index.del')}}</el-button>
						</template>
				    </el-table-column>
				</el-table>
			</el-form>
			<el-dialog :title="$t('student_list.edit_remarks')" data-title="修改备注" width="500px" :close-on-click-modal="false" :visible="remarks_edit_is" @close="remarks_edit_is = false" append-to-body>
				<el-row class="tree-content" :gutter="20">
					<el-form :model="remarks" size="mini" label-width="55px" label-position="top" :rules="rules" ref="remarks">
						<el-col :span="24">
							<el-form-item :label="$t('student_list.remarks')" prop="remarks">
								<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" :placeholder="$t('index.pleaseInput')" v-model="remarks.remarks"></el-input>
							</el-form-item>
						</el-col>
					</el-form>
				</el-row>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click.native="remarks_edit_is = false">{{$t('index.cancel')}}</el-button>
					<el-button size="mini" type="primary" @click.native="editSubmit_remarks('')">{{$t('index.submit')}}</el-button>
				</div>
			</el-dialog>
		</el-dialog>
		<!-- 信息修改 -->
		<el-dialog :title="$t('index.dialog_title')" :close-on-click-modal="false" :visible.sync="editFormVisible" width="1000px">
			<el-form ref="editForm" size="mini" :model="editForm" :rules="editFormRules" label-position="top">
				<div class="input_yincang">
					<div class="">
						<input type="text" name="name">
						<input type="password" name="password">
					</div>
				</div>
				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.tel')" prop="tel">
							<el-input v-model="editForm.tel" class="w100" autocomplete="off" :disabled="!!editForm.id"  :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.password')" :prop="!editForm.id?'password':''">
							<el-input v-model="editForm.password" show-password class="w100" autocomplete="off" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.re_password')" :prop="!editForm.id?'re_password':''">
							<el-input v-model="editForm.re_password" show-password class="w100" autocomplete="off" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.name')" prop="name">
							<el-input v-model="editForm.name" class="w100" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.email')" prop="email">
							<el-input v-model="editForm.email" class="w100" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.wechat')" prop="wechat_id">
							<el-input v-model="editForm.wechat_id" class="w100" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.province')" prop="province">
							<el-input v-model="editForm.province" class="w100" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.referred_tel')" prop="referred_tel">
							<el-input v-model="editForm.referred_tel" class="w100" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.group_type')" prop="group_type">
							<el-select v-model="editForm.group_type" class="w100" clearable :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in CUSTOMER_LEVEL" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.seller')" prop="seller_id">
							<el-select v-model="editForm.seller_id" class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in sellerList" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="是否再小程序编辑课程" prop="is_admin">
							<el-select v-model="editForm.is_admin" class="w100" :placeholder="$t('index.select')">
								<el-option label="否" :value="0"></el-option>
								<el-option label="是" :value="1"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-for="(item,index) in editForm.children" :key="index" :gutter="20">
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.user_email')" :prop="'children.'+index+'.user_name'" :rules="rules.user_name1">
							<el-input v-model="item.user_name" class="w100" placeholder=""></el-input>
						</el-form-item>
						<el-form-item :label="$t('parent_index.name_child_cn')" :prop="'children.'+index+'.name'" :rules="rules.name_child">
							<el-input v-model="item.name_cn" class="w100" placeholder=""></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.login_user_name')" :prop="'children.'+index+'.login_user_name'" :rules="rules.login_user_name">
							<el-input v-model="item.login_user_name" class="w100" placeholder=""></el-input>
						</el-form-item>
						<el-form-item :label="$t('parent_index.name_child')" :prop="'children.'+index+'.name'" :rules="rules.name_child">
							<el-input v-model="item.name" class="w100" placeholder=""></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.grade')" prop="grade">
							<el-select v-model="item.grade" class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in GRADE_LIST" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="Number(item.code)"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('parent_index.year')" :prop="'children.'+index+'.year_month'" :rules="rules.year_month">
							<el-date-picker v-model="item.year_month" class="w100" @change="year_month_f(item.year_month,index)" value-format="yyyy-MM" type="month"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('parent_index.thumb')" :prop="'children.'+index+'.thumb'" :rules="rules.thumb">
							<upload :value="item.thumb" :name="index" @callback="function(res, file){imageSuccess(res, file,'thumb')}"></upload>
						</el-form-item>
					</el-col>
					<el-col :span="2"><i class="el-icon-remove line" @click="remove(item,index)"></i></el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" @click.native="add_child('editForm')">{{$t('index.add_child')}}</el-button>
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<!-- 发送优惠券 -->
		<el-dialog :title="$t('index.dialog_title')" :close-on-click-modal="false" :visible.sync="coupon_is" width="500px">
			<el-form ref="coupon_form" size="mini" :model="coupon_form" :rules="rules" label-position="top">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item :label="$t('parent_index.coupon_id')" prop="coupon_id">
				            <el-select v-model="coupon_form.coupon_id" class="w100" multiple :placeholder="$t('index.select')">
					        	<el-option :label="lang=='cn'?item.name_cn:item.name" :value="Number(item.id)" v-for="(item,index) in couponlist" :key="index"></el-option>
				            </el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item :label="$t('parent_index.remarks')" prop="remark">
							<el-input v-model="coupon_form.remarks" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="coupon_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="coupon_f()">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<!-- 订单 -->
		<order_list :email="order_list_email" @guanbi="order_list_email=''"></order_list>
		<!-- 备注 -->
		<el-dialog :title="$t('feedback_index.remarks')" width="800px" :close-on-click-modal="false" :visible="editFormVisible1" @close="editFormVisible1 = false">
			<el-form :model="editForm1" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm1">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item :label="$t('feedback_index.remarks')" prop="remarks">
							<el-input v-model="editForm1.remarks" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible1 = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit1('editForm1')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<!-- <el-dialog :title="$t('feedback_index.history')" width="90%" :close-on-click-modal="false" :visible="history_is" @close="history_is = false">
			<history :user_id="user_id_id" v-if="history_is"></history>
		</el-dialog> -->
		<el-dialog :title="$t('feedback_index.history')" width="90%" :close-on-click-modal="false" :visible="history_is" @close="history_is = false">
			<history :user_id="user_id_id" v-if="history_is"></history>
		</el-dialog>
		<el-dialog :title="$t('feedback_index.coupon_list')" width="1200px" :close-on-click-modal="false" :visible="coupon_list_is" @close="coupon_list_is = false">
			<coupon_list :user_id="user_id_id" v-if="coupon_list_is"></coupon_list>
		</el-dialog>
	</div>
</template>
<script>
import order_list from '@/components/order_list.vue'
import history from '@/components/sellerOrderList.vue'
import coupon_list from './components/coupon_list.vue'
export default {
	components: {
		order_list,history,coupon_list
	},
	computed: {
		rules() {
			return {
				// user_name: [{
				// 	required: true,
				// 	message: this.$t('index.input') + this.$t('parent_index.user_name'),
				// 	trigger: 'blur'
				// }],
				user_name1: [{
					required: true,
					message: this.$t('index.input') + this.$t('parent_index.user_email'),
					trigger: 'blur'
				}],
				password: [{
					required: true,
					message: this.$t('index.input') + this.$t('parent_index.password'),
					trigger: 'blur'
				}],
				remarks: [{
					required: true,
					message: this.$t('index.input') + this.$t('parent_index.remarks'),
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: this.$t('index.input') + this.$t('parent_index.name'),
					trigger: 'blur'
				}],
				tel: [{
					required: true,
					message: this.$t('index.input') + this.$t('parent_index.tel'),
					trigger: 'blur'
				}],
				email: [{
					required: true,
					message: this.$t('index.input') + this.$t('parent_index.email'),
					trigger: 'blur'
				}],
				wechat_id: [{
					required: true,
					message: this.$t('index.input') + this.$t('parent_index.wechat'),
					trigger: 'blur'
				}],
				province: [{
					required: true,
					message: this.$t('index.input') + this.$t('parent_index.province'),
					trigger: 'blur'
				}],
				name_child: [{
					required: true,
					message: this.$t('index.input') + this.$t('parent_index.name_child'),
					trigger: 'blur'
				}],
				year_month: [{
					required: true,
					message: this.$t('index.select') + this.$t('parent_index.year'),
					trigger: 'blur'
				}],
				coupon_id: [{
					required: true,
					message: this.$t('index.select') + this.$t('parent_index.coupon_id'),
					trigger: 'cheng'
				}],
			}
		}
	},
	data() {
		const validatorEmail = (rule, value, callback) => {
			if (!value) {
				return callback(new Error(this.$t('index.input') + this.$t('parent_index.password')));
			} else {
				if (value==this.editForm.password) {
					callback();
				} else {

					return callback(new Error(this.$t('parent_index.thetwo')))
				}
			}
		};
		return {
			editFormRules: {
				re_password: [{
					required: true,
					validator: validatorEmail,
					trigger: 'blur'
				}],
			},
			image_up: process.env.API_UP,
			filterForm: {
			},
			list: [],
			pages: {
				email: '',
				referred_email: '',
				sort_filed:'',
				sort_type:'',
				group_type:'',
				tel:'',
				seller_id:'',
				province:'',
				name:'',
				student_name :'',
				time:null,
				student_age_min :'',
				student_age_max :'',
				page: 1,
				count: 0,
				perpage: 10,
			},
			//TIME_COUNTRY: [],  // 所属国家
			sellerList: [], //销售列表
			editFormVisible: false,
			editForm: {},
			editFormVisible_is: false,
			
			editForm_form:{
				user_id:'',
				score_min:'',
				jiajian:1,
				score:0,
				remarks:'',
				all_get:'',
			},
			remarks_edit_is: false,
			editForm_list:[],
			data_data:{},

			remarks: {
				remarks: '',
				id: '',
			},
			coupon_is:false,
			coupon_form:{
				coupon_id:'',
				remarks:'',
			},
			user_id:[],
			couponlist:[],
			CUSTOMER_LEVEL:[],
			GRADE_LIST:[],
			order_list_email:'',
			editForm1:{
				remarks:'',
				id:'',
			},
			editFormVisible1:false,
			history_is:false,
			user_id_id:0,
			coupon_list_is:false,
		}
	},
	// 初始事件
	mounted: function () {

		this.editFormRules=Object.assign(this.rules,this.editFormRules);
		this.filterForm.email=this.$route.query.email||'';
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			this.$post('sellerListNoPage', {seller_type:'seller'}).then((res) => {
				this.sellerList = res;
			})
			this.$post('getDictionaryValue', {code:'CUSTOMER_LEVEL,GRADE_LIST'}).then((res) => {
				this.CUSTOMER_LEVEL = res.CUSTOMER_LEVEL;
				this.GRADE_LIST = res.GRADE_LIST;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "userList";
			var datas = {
				...this.pages,
				// email: this_.filterForm.email,
				// name: this_.filterForm.name,
				// referred_email: this_.filterForm.referred_email,
				// sort_filed: this_.filterForm.sort_filed,
				// sort_type: this_.filterForm.sort_type,
				// group_type: this_.filterForm.group_type,
				// tel: this_.filterForm.tel,
				// province: this_.filterForm.province,
				// seller_id: this_.filterForm.seller_id,
				// student_name: this_.filterForm.name_child,
				// student_age_min: this_.filterForm.student_age_min,
				// student_age_max: this_.filterForm.student_age_max,
				num: this.pages.perpage,
			};
			if (this.pages.time) {
				datas['start_time']=Math.round(this.pages.time[0]/1000);
				datas['end_time']=Math.round(this.pages.time[1]/1000);
			}
			this.$post(url, datas).then((res) => {
				this.list = res.list;
				this.pages.count = res.sum;
			})
		},
		search() {
			this.pages.page = 1;
			this.init();
		},
		reset() {
			this.pages = this.$options.data().pages;
			this.init();
		},
		// 排序
		sort_change(data){
			this.pages.sort_filed=data.prop;
			if (data.order=="ascending") {
				this.pages.sort_type='desc';
			}else if(data.order=="descending"){
				this.pages.sort_type='asc';
			}else {
				this.pages.sort_type='';
			}
			this.init(1);
		},
		// // 重置
		// reset() {
		// 	this.filterForm.email = '';
		// 	this.filterForm.referred_email = '';
		// 	this.filterForm.tel = '';
		// 	this.filterForm.group_type = '';
		// 	this.filterForm.province = '';
		// 	this.filterForm.name = '';
		// 	this.filterForm.seller_id = '';
		// 	this.filterForm.name_child = '';
		// 	this.filterForm.time=null;
		// 	this.handleCurrentChange(1);
		// },
		// // 分页每页显示几条
		// handleSizeChange(val) {
		// 	var pages = this.pages;
		// 	pages['perpage'] = val;
		// 	this.pages = pages;
		// 	this.init();
		// },
		// // 切换分页
		// handleCurrentChange(val) {
		// 	var pages = this.pages;
		// 	pages['page'] = val;
		// 	this.pages = pages;
		// 	this.init();
		// },
		add(data) {
			if (data) {
				var data_data = JSON.parse(JSON.stringify(data));
				var children = data_data.children;
				children.forEach(function (e, i) {
					var year_month = e.birthday_year + '-' + e.birthday_month;
					e['year_month'] = year_month;
				});
				this.editForm = data_data;
				this.editForm['children'] = children;
			}else{
				this.editForm={
					user_name:'',
					password:'',
					re_password:'',
					email:'',
					name:'',
					province:'',
					tel:'',
					wechat_id:'',
					referred_email:'',
					children:[],
					seller_id:'',
					seller_id:'',
					group_type:'',
					is_delete:0,
					is_admin:0,
				}
			}
			this.editFormVisible = true;
		},
		// 添加孩子
		add_child() {
			var obj = {
				name: '',
				name_cn: '',
				year_month: '',
				grade: '',
				birthday_month: '',
				birthday_year: '',
				thumb: '',
				login_user_name: '',
			}
			this.editForm.children.push(obj);
		},
		// 删除孩子
		remove(data, index) {
			var this_ = this;
			var url = "deleteUserStudent";
			var datas = {
				user_id: data.parent_id,
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				if (data.id) {
					this_.$post(url, datas).then((res) => {
						this_.removeByIndex(this_.editForm.children, index);
					})
				} else {
					this_.removeByIndex(this_.editForm.children, index);
				}
			}).catch(() => {});
		},
		// 保存
		editSubmit() {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var children_data = this.editForm.children;
					var children = [];
					children_data.forEach(function (e, i) {
						var obj = {
							id: e.id || '',
							name: e.name,
							name_cn: e.name_cn,
							birthday_month: e.birthday_month,
							birthday_year: e.birthday_year,
							thumb: e.thumb_yl,
							user_name: e.user_name,
							grade: e.grade,
							login_user_name: e.login_user_name,
						}
						children[i] = obj;
					});
					var datas = {
						user_name: this_.editForm.user_name,
						email: this_.editForm.email,
						name: this_.editForm.name,
						province: this_.editForm.province,
						tel: this_.editForm.tel,
						wechat_id: this_.editForm.wechat_id,
						group_type: this_.editForm.group_type,
						seller_id: this_.editForm.seller_id,
						referred_email: this_.editForm.referred_email,
						is_admin: this_.editForm.is_admin,
						children: children.length > 0 ? JSON.stringify(children) : '',
					};
					var url = "adminAddUser";
					if (this_.editForm.user_id) {
						url = "editUserInfo";
						datas['user_id']=this_.editForm.user_id
						if (this_.editForm.password!=this_.editForm.re_password) {
							this_.$message.success(this_.$t('parent_index.thetwo'));
							return false;
						}
					}
					if (this_.editForm.password) {
						datas['password']=this_.editForm.password
					}
					this_.$post(url, datas).then(res => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.init();
						this_.editFormVisible = false;
					}).catch(res => {})
				} else {
					return false;
				}
			})
		},
		// 年月选择回调
		year_month_f(data, index) {
			if (data) {
				this.editForm.children[index].birthday_year = data.split('-')[0];
				this.editForm.children[index].birthday_month = data.split('-')[1];
			} else {
				this.editForm.children[index].birthday_year = '';
				this.editForm.children[index].birthday_month = '';
			}
		},
		// 图片上传回调
		imageSuccess(res, file, name) {
			if (res.status == 200) {
				this.editForm.children[res.data.name]['thumb'] = res.data.showname;
				this.editForm.children[res.data.name]['thumb_yl'] = res.data.savename;
				this.$refs.editForm.clearValidate(name);
			} else {
				this.$message.success(res.message);
			}
		},
		// 修改积分 获取积分记录
		integral(data){
			var this_ = this;
			var url = "adminScoreRecord";
			var datas = {
				user_id:data.user_id,
				page: 1,
				num:99999,
			};
			this_.data_data=data;
			this_.$post(url, datas).then((res) => {
				this_.editForm_list = res.list;
				this_.editForm_form.user_id= data.user_id;
				this_.editForm_form.score_min= JSON.parse(JSON.stringify(data.score));
				this_.editForm_form.score= 0;
				this_.editForm_form.remarks= '';
				this_.editForm_form.all_get= JSON.parse(JSON.stringify(data.all_get));;
				this_.editFormVisible_is=true;
			})
		},
		// 修改积分保存
		editSubmit_is(){
			var this_ = this;
			this_.$refs.editForm_form.validate((valid) => {
				if (valid) {
					var datas = {
						score: this_.editForm_form.score,
						jiajian: this_.editForm_form.jiajian,
						remarks: this_.editForm_form.remarks,
						user_id: this_.editForm_form.user_id,
					};
					var url = "adminScoreAction";
					this_.$post(url, datas).then(res => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.init();
						this_.editFormVisible_is = false;
					}).catch(res => {})
				} else {
					return false;
				}
			})
		},
		// 删除积分记录
		del_jilu(data) {
			var this_ = this;
			var url = "deleteAdminScoreRecord";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.data_data.score = res.score;
					this_.integral(this_.data_data);
				})
			}).catch(() => {});
		},
		// 修改备注
		remarks_edit(data) {
			var data_data=JSON.parse(JSON.stringify(data));
			this.remarks.id = JSON.parse(JSON.stringify(data_data.id))||'';
			this.remarks.remarks = JSON.parse(JSON.stringify(data_data.name))||'';
			this.remarks_edit_is = true;
		},
		editSubmit_remarks() {
			var this_ = this;
			this_.$refs.remarks.validate((valid) => {
				if (valid) {
					var datas = {
						remarks: this_.remarks.remarks,
						id: this_.remarks.id,
					}
					var url = "editAdminScoreRecord";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.remarks_edit_is = false;
						this_.integral(this_.data_data);
					});
				} else {
					return false;
				}
			})
		},
		handleSelectionChange(data){
			var user_id=[];
			data.forEach(function(e,i) {
				user_id[i]=e.user_id;
			});
			this.user_id=user_id;
		},
		// 优惠券
		coupon(){
			var this_ = this;
			if (this_.user_id&&this_.user_id.length) {
				var url = "CouponListNoPage";
				this_.$post(url, {}).then((res) => {
					this_.couponlist = res;
					this_.coupon_is=true;
					this_.coupon_form.coupon_id = [];
					this_.coupon_form.remarks = '';
				})
			}else{
				this_.$message.success(this_.$t('index.please_check'));
			}
		},
		coupon_f(){
			var this_ = this;
			this_.$refs.coupon_form.validate((valid) => {
				if (valid) {
					var datas = {
						coupon_id: this_.coupon_form.coupon_id.join(','),
						user_id: this_.user_id.join(','),
						remark:this_.coupon_form.remarks,
					}
					var url = "sendCoupon";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.coupon_is = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		exportUserList(){
			var TokenId = sessionStorage.getItem('TokenId');
			var lang  = localStorage.getItem('lang')!='cn'?'us':'cn';
			var url =  process.env.API_ROOT+'exportUserList?TokenId='+TokenId+'&language='+lang;
			var filterForm=this.pages;
			for (var i in filterForm) {
				if (i=='time'&&filterForm[i]&&filterForm[i].length) {
					url+='&start_time='+Math.round(filterForm[i][0]/1000)+'&end_time='+Math.round(filterForm[i][1]/1000);
				}else{
					if (filterForm[i]) {
						url+='&'+i+'='+filterForm[i]
					}
				}
			}
			console.log(url)
			window.open(url);
		},
		exportUserList1(){
			var TokenId = sessionStorage.getItem('TokenId');
			var lang  = localStorage.getItem('lang')!='cn'?'us':'cn';
			var url =  process.env.API_ROOT+'exportNowOpenCourse?TokenId='+TokenId+'&language='+lang;
			var filterForm=this.filterForm;
			for (var i in filterForm) {
				if (i=='time'&&filterForm[i]&&filterForm[i].length) {
					url+='&start_time='+Math.round(filterForm[i][0]/1000)+'&end_time='+Math.round(filterForm[i][1]/1000);
				}else{
					if (filterForm[i]) {
						url+='&'+i+'='+filterForm[i]
					}
				}
			}
			console.log(url)
			window.open(url);
		},
		remarks_ff(data){
			this.editForm1.id=data.id;
			this.editForm1.remarks=data.remarks;
			this.editFormVisible1=true;
		},
		editSubmit1(editForm){
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var datas = {
						table: 'user',
						field: 'remarks',
						value: this_.editForm1.remarks,
						pk_id: this_.editForm1.id,
					}
					var url = "changeField";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.add_success'));
						this_.editFormVisible1 = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		del(){
			if (this.user_id&&this.user_id.length) {
				var url = "userDelete";
				this.$confirm(this.$t('index.confirm_delete'), this.$t('index.tips')).then(() => {
					this.$post(url, {id: this.user_id.join(',')}).then((res) => {
						this.$message.success(this.$t('index.add_success'));
						this.init();
					})
				})
			}else{
				this.$message.success(this.$t('index.please_check'));
			}
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 22px;
	display: flex;
}
.page-pagination {
	padding: 20px 10px;
}
.filter-panel {
/* 	width: calc(100% - 135px); */
/* 	float: left; */
flex: 1;
}
.line {
	font-size: 26px;
	cursor: pointer;
	margin-top: 30px;
}
.dialog-footer{
	text-align: right;
/* 	margin-bottom: 20px; */
}
.input_yincang{
	width: 0;
	height: 0;
	position: relative;
	overflow: hidden;
}
.input_yincang>div{
	position: absolute;left: 100px;
	top: 100px;
}
</style>
<style>
textarea{
	font-family:inherit;
}
</style>



// WEBPACK FOOTER //
// src/views/parent/index.vue